export const defaultAssetFields = {
  deals: 'id',
  portfolio: ['id', 'name'].join(','),
  city: ['id', 'name'].join(','),
  image: 'id',
  assets: [
    'normalized_address',
    'source_address',
    'longitude',
    'latitude',
    'main_type_of_use',
    'total_area',
    'total_net_area_main_type',
    'total_net_area',
    'total_net_rent_main_type_monthly',
    'plot_size',
    'vacancy_percent',
    'vacancy_area',
    'walt',
    'main_tenant',
    'construction_year',
    'source_construction_year',
    'refurbishment_year',
    'source_refurbishment_year',
    'partial_ownership_info',
    'number_of_buildings',
    'measured_by',
    'origin',
    'rentroll_state',
    'total_net_rent_monthly',
    'currency_code',
    'currency_exchange_rates',
    'updated_at',
    'created_at',
    'asset_name',
    'asset_description',
    'project_name',
    'spv',
    'seller_spv',
    'source_portfolio_name',
    'source_portfolio_ref_id',
    'manager_portfolio',
    'manager_asset',
    'manager_property',
    'asset_status',
    'country_code',
    'building_type',
    'refurbishment_degree',
    'source_refurbishment_degree',
    'capex_invested',
    'energy_certificate_info',
    'ti_invested_units',
    'ti_invested_area',
    'ti_invested_amount',
    'units_refurbished',
    'units_partly_refurbished',
    'units_unrefurbished',
    'roof_developed',
    'facade_insulated',
    'windows_insulated',
    'heating',
    'elevator_info',
    'balcony_info',
    'cadastral_map',
    'land_register',
    'floor_cadastral',
    'land_parcel',
    'sole_ownership_info',
    'ab_existent_info',
    'has_leasehold',
    'leasehold_term_date',
    'easements_info',
    'public_subsidy_type',
    'public_subsidy_amount',
    'public_subsidy_term_date',
    'flood_area_info',
    'construction_law_info',
    'total_units',
    'listed_property_info',
    'development_expenses',
    'undeveloped',
    'index_floor_space',
    'index_site_occupancy',
    'land_use_plan',
    'asking_price_date',
    'rentroll_date',
    'asking_price',
    'acquisition_date',
    'acquisition_price_net',
    'acquisition_side_costs',
    'acquisition_transfer_of_ownership',
    'sales_date',
    'sales_price_net',
    'sales_transfer_of_ownership',
    'source_asset_ref_id',
    'market_valuation_date',
    'market_value',
    'cluster_asset',
    'cluster_portfolio',
    'subportfolio',
    'external_link',
    'spv_id',
    'gross_floor_area',
    'group_rent_yearly',
    'has_public_subsidy',
    'has_balcony',
    'has_elevator',
    'has_energy_certificate',
    'has_sole_ownership',
    'has_partial_ownership',
    'has_ab_existent',
    'has_easements',
    'has_construction_law',
    'has_listed_property',
    'has_flood_area',
    'has_contamination',
    'has_building_encumbrance',
    'has_preservation_statute',
    'has_redevelopment_area',
    'has_development_area',
    'has_urban_reconstruction_area',
    'building_encumbrance_info',
    'contamination_info',
    'development_area_info',
    'preservation_statute_info',
    'redevelopment_area_info',
    'urban_reconstruction_area_info',
    'market_rent_appraisal',
    'zone_id',
    'cap_rate',
    'market_name',
    'district_name'
  ].join(','),
};
